import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/data";
import { SectionHead, SHELL, Reveal, TiltCard } from "@/components/bits";

export default function Categories() {
    return (
        <section id="categories" className="relative py-24 md:py-32" data-testid="categories-section">
            <SHELL>
                <SectionHead
                    index="06"
                    label="RWA UNIVERSE"
                    title={"EVERY CATEGORY. ONE CAPITAL LAYER."}
                    sub="Eight real-world asset classes, each with its own economics — unified by verification, pools and USDC settlement."
                />
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {CATEGORIES.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <TiltCard key={c.id} testid={`category-card-${c.id}`} className="h-full">
                                <Link to="/assets" className="glass-card p-7 h-full flex flex-col group hover:border-vera-blue/50 transition-colors">
                                    <div className="w-11 h-11 border border-vera-blue/40 bg-vera-deep/60 flex items-center justify-center mb-9 group-hover:border-vera-gold/60 transition-colors">
                                        <Icon className="w-5 h-5 text-vera-soft group-hover:text-vera-gold2 transition-colors" strokeWidth={1.5} aria-hidden="true" />
                                    </div>
                                    <h3 className="font-mono text-[11px] tracking-[0.25em] mb-3">{c.label}</h3>
                                    <p className="text-sm text-vera-mut leading-relaxed flex-1">{c.desc}</p>
                                    <span className="font-mono text-[9px] tracking-[0.25em] text-vera-mut/60 mt-8 group-hover:text-vera-gold2 transition-colors">
                                        {String(i + 1).padStart(2, "0")} — EXPLORE <ArrowUpRight className="inline w-3 h-3 ml-1" aria-hidden="true" />
                                    </span>
                                </Link>
                            </TiltCard>
                        );
                    })}
                </div>
            </SHELL>
        </section>
    );
}
